import { render, staticRenderFns } from "./garage.vue?vue&type=template&id=094c995b&scoped=true"
import script from "./garage.vue?vue&type=script&lang=js"
export * from "./garage.vue?vue&type=script&lang=js"
import style0 from "./garage.vue?vue&type=style&index=0&id=094c995b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094c995b",
  null
  
)

export default component.exports